import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {CoffeeCode} from '../../classes/CoffeeCode';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class UserCoffeeService {

  constructor(private httpClient: HttpClient) { }

  public makeCoffee(coffeeCode: string): Observable<void> {
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/users/coffee`, {coffeeCode}, httpOptions);
  }

  public createCoffeeCode(): Observable<CoffeeCode> {
    return this.httpClient.post<CoffeeCode>(`${environment.backendApiUrl}/v1/users/coffee-code`, httpOptions);
  }

  public getCoffeeCodeStatus(id: number): Observable<CoffeeCode> {
    return this.httpClient.get<CoffeeCode>(`${environment.backendApiUrl}/v1/users/coffee-code/` + id, httpOptions);
  }
}
